import { createReducer, on } from '@ngrx/store';
import { setStateAction } from '../actions/admin-settlement-report.actions';
import { Action } from '../../models';
import dayjs from 'dayjs';

export interface Settlement {
  taxPayerName: string;
  mda: string;
  createdAt: string;
  modifiedAt: string;
  revenueHead: string;
  id: string;
  taxOffice: string;
  invoiceNumber: string;
  amount: string;
}

export interface SettlementReportReducerInitialState {
  maxDate: string;
  minDate: string;
  status: string;
  rhId: string;
}

export const initialState: SettlementReportReducerInitialState = {
  maxDate: '',
  minDate: '',
  status: '',
  rhId: '',
};

const reducer = createReducer(
  initialState,
  on(setStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  })
);

export function settlementReportReducerReducer(
  state: SettlementReportReducerInitialState,
  action: Action
) {
  return reducer(state, action);
}
